import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90145506"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-group-page" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-info",
  role: "status"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fw-bold mb-1" }, "Times"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-0" }, " Forme um time e dispute o ranking de campeonato. ")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "card mb-6"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Convites recebidos")
], -1))
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "fw-bold" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "text-muted small" }
const _hoisted_13 = { class: "d-flex gap-2" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-body text-center py-10" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "Você ainda não faz parte de um time.", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Criar um time ")
const _hoisted_20 = { class: "d-flex align-items-center justify-content-between mb-6" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "position-relative me-4" }
const _hoisted_23 = { class: "symbol symbol-70px" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-8" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "fw-bold mb-1" }
const _hoisted_29 = { class: "text-muted" }
const _hoisted_30 = { class: "text-muted mb-0" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "fw-bold fs-2 text-info" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "pontos", -1))
const _hoisted_35 = {
  key: 0,
  class: "text-muted small mb-4"
}
const _hoisted_36 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_37 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_38 = {
  key: 3,
  class: "alert alert-success"
}
const _hoisted_39 = { class: "card mb-6" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Membros")
], -1))
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = { class: "symbol symbol-40px me-3" }
const _hoisted_44 = ["src"]
const _hoisted_45 = {
  key: 0,
  class: "badge badge-light-info ms-2"
}
const _hoisted_46 = {
  key: 0,
  class: "d-flex gap-2"
}
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = ["disabled", "onClick"]
const _hoisted_49 = {
  key: 4,
  class: "card mb-6"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Editar time")
], -1))
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = { class: "row g-4" }
const _hoisted_53 = { class: "col-md-7" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Nome do time", -1))
const _hoisted_55 = { class: "col-md-5" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tag", -1))
const _hoisted_57 = { class: "mt-4" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 5,
  class: "card mb-6"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Convidar membro")
], -1))
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = { class: "d-flex gap-3 mb-4" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-muted mb-2" }, "Convites pendentes", -1))
const _hoisted_67 = ["disabled", "onClick"]
const _hoisted_68 = { class: "d-flex gap-3" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!_ctx.group)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_5,
            (_ctx.invitations.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitations, (inv) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: inv.id,
                        class: "d-flex align-items-center justify-content-between border-bottom py-3"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_9, [
                            (_ctx.flagUrl(inv.group.country))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.flagUrl(inv.group.country),
                                  class: "country-flag me-1",
                                  alt: ""
                                }, null, 8, _hoisted_10))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(inv.group.tag), 1),
                            _createTextVNode(" " + _toDisplayString(inv.group.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, " Convidado por " + _toDisplayString(inv.invited_by?.nick), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-info",
                            disabled: _ctx.busy,
                            onClick: ($event: any) => (_ctx.acceptInvite(inv.id))
                          }, " Aceitar ", 8, _hoisted_14),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light",
                            disabled: _ctx.busy,
                            onClick: ($event: any) => (_ctx.declineInvite(inv.id))
                          }, " Recusar ", 8, _hoisted_15)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_router_link, {
                  to: "/groups/create",
                  class: "btn btn-info"
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("img", {
                      src: _ctx.group.icon_path || '/media/avatars/blank.png',
                      alt: ""
                    }, null, 8, _hoisted_24)
                  ]),
                  (_ctx.isCaptain)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-icon btn-sm btn-info group-icon-edit",
                        disabled: _ctx.busy,
                        title: "Alterar ícone do time",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.iconInput?.click()))
                      }, _hoisted_27, 8, _hoisted_25))
                    : _createCommentVNode("", true),
                  _createElementVNode("input", {
                    ref: "iconInput",
                    type: "file",
                    accept: "image/png,image/jpeg",
                    class: "d-none",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadIcon && _ctx.uploadIcon(...args)))
                  }, null, 544)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_28, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.group.tag), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.group.name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_30, [
                    (_ctx.flagUrl(_ctx.group.country))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.flagUrl(_ctx.group.country),
                          class: "country-flag me-1",
                          alt: ""
                        }, null, 8, _hoisted_31))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.countryName(_ctx.group.country)) + " · " + _toDisplayString(_ctx.group.members_count) + "/" + _toDisplayString(_ctx.maxMembers) + " membros ", 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.group.points), 1),
                _hoisted_34
              ])
            ]),
            (_ctx.isCaptain)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, " O ícone é cortado automaticamente em um quadrado e redimensionado para 500x500. "))
              : _createCommentVNode("", true),
            (!_ctx.group.is_rankable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Este time precisa de ao menos " + _toDisplayString(_ctx.minMembers) + " membros para aparecer no ranking. ", 1))
              : _createCommentVNode("", true),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true),
            (_ctx.notice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.notice), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.members, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.id,
                    class: "d-flex align-items-center justify-content-between border-bottom py-3"
                  }, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("img", {
                          src: m.profile_photo_path || '/media/avatars/blank.png',
                          alt: ""
                        }, null, 8, _hoisted_44)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_router_link, {
                          to: `/profile/user/${m.id}`,
                          class: "fw-bold text-reset"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(m.nick || m.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (m.group_role === 'captain')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, " Capitão "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.isCaptain && m.group_role !== 'captain')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light-info",
                            disabled: _ctx.busy,
                            onClick: ($event: any) => (_ctx.transferCaptain(m))
                          }, " Tornar capitão ", 8, _hoisted_47),
                          _createElementVNode("button", {
                            class: "btn btn-sm btn-light-danger",
                            disabled: _ctx.busy,
                            onClick: ($event: any) => (_ctx.removeMember(m.id))
                          }, " Remover ", 8, _hoisted_48)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.isCaptain)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editForm.name) = $event)),
                          type: "text",
                          class: "form-control",
                          maxlength: "60"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.editForm.name,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editForm.tag) = $event)),
                          type: "text",
                          class: "form-control text-uppercase",
                          maxlength: "8"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.editForm.tag,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("button", {
                        class: "btn btn-info",
                        disabled: _ctx.busy || !_ctx.editChanged || !_ctx.editValid,
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)))
                      }, " Salvar alterações ", 8, _hoisted_58)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isCaptain)
              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                  _hoisted_60,
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inviteNick) = $event)),
                        type: "text",
                        class: "form-control",
                        placeholder: "Nick do aluno no HackingClub",
                        disabled: _ctx.busy || _ctx.group.members_count >= _ctx.maxMembers
                      }, null, 8, _hoisted_63), [
                        [
                          _vModelText,
                          _ctx.inviteNick,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-info",
                        disabled: _ctx.busy || !_ctx.inviteNick || _ctx.group.members_count >= _ctx.maxMembers,
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendInvite && _ctx.sendInvite(...args)))
                      }, " Convidar ", 8, _hoisted_64)
                    ]),
                    (_ctx.group.pending_invitations?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _hoisted_66,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.pending_invitations, (inv) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: inv.id,
                              class: "d-flex align-items-center justify-content-between py-2"
                            }, [
                              _createElementVNode("span", null, _toDisplayString(inv.invited_user?.nick), 1),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-light",
                                disabled: _ctx.busy,
                                onClick: ($event: any) => (_ctx.cancelInvite(inv.id))
                              }, " Cancelar ", 8, _hoisted_67)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("button", {
                class: "btn btn-light-danger",
                disabled: _ctx.busy,
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.leaveGroup && _ctx.leaveGroup(...args)))
              }, " Sair do time ", 8, _hoisted_69),
              (_ctx.isCaptain)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-light-danger",
                    disabled: _ctx.busy,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.dissolveGroup && _ctx.dissolveGroup(...args)))
                  }, " Dissolver time ", 8, _hoisted_70))
                : _createCommentVNode("", true)
            ])
          ], 64))
  ]))
}